import { buildEndpoint, NOTIFICACOES_EXTENSION } from "./api.service";
import axios from 'axios';




export async function getNotificacoes() {
    const response = await axios.get(buildEndpoint(NOTIFICACOES_EXTENSION))
    const notificacoes = response.data.map((o : any) => {
        return createNotificacoesData(o)
      })
    return notificacoes;
}


export async function deleteNotificacao(id : string) {
    return await axios.delete(buildEndpoint(NOTIFICACOES_EXTENSION) + '/' + id);
}


export async function readNotification(id : string) {
    return await axios.post(buildEndpoint(NOTIFICACOES_EXTENSION) + '/read/' + id,{});
}

export async function readAllNotifications() {
    return await axios.post(buildEndpoint(NOTIFICACOES_EXTENSION) + '/read-all' ,{});
}


function createNotificacoesData ({id,message, created_at, entity, read, entityId, entityRoute, state} : any) {

    const notificacao = {id, message, entity, read, created_at, entityId, entityRoute, state};
    return notificacao;


}